import { PropsWithChildren } from 'react';
import { SegmentHandler } from '@repo/segment';
import styles from './AppLayout.module.css';

SegmentHandler.instance.init(import.meta.env.VITE_APP_SEGMENT_WRITE_KEY!);

export const AppLayout = ({ children }: PropsWithChildren) => {
  return (
    <>
      <div className={styles.appWrapper}>
        <div className={styles.pageWrapper}>{children}</div>
      </div>
    </>
  );
};
export default AppLayout;
